module.exports = "img/photo18.ad9270.jpeg";